import { Helmet } from 'react-helmet-async';
import React from 'react';
import ProjectFormContainer from '../../containers/projects/ProjectFormContainer.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

const NewProject = ({ slug, portfolioId }) => (
  <>
    <Helmet>
      <title>New {getOrgTermsContent('project')} | ChangeSync</title>
    </Helmet>
    <ProjectFormContainer slug={slug} portfolioId={portfolioId} />
  </>
);

NewProject.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  portfolioId: Number(query.portfolioId),

  slug: query.slug,
});

export default requireAuth(withRouterParams(NewProject));
